<template>
  <div>
    <div>
      <!-- <div class="success--text pa-4 pt-0" v-if="is_superuser">
        Note: Now you are eligible to create Premium Groups
      </div> -->

      <div
        :class="
          !$vuetify.breakpoint.xsOnly
            ? 'd-flex overflow-x-auto overflow-y-hidden'
            : ''
        "
      >
        <!-- <group-create-btn></group-create-btn> -->
        <!-- <group-skeleton-loader
          v-if="updates.length === 0 && loading"
        ></group-skeleton-loader> -->
        <v-row class="ma-0" v-if="loading">
          <v-col cols="12" md="4" sm="12" v-for="item in 3" :key="item">
            <v-card class="mt-2">
              <v-skeleton-loader
                :type="
                  $vuetify.breakpoint.xsOnly ? 'article' : 'image, article'
                "
              />
            </v-card>
          </v-col>
        </v-row>
        <group-horizontal-list
          class="mb-5"
          :groups="updates"
        ></group-horizontal-list>
      </div>
    </div>
  </div>
</template>

<script>
// import GroupCreateBtn from "./GroupCreateBtn.vue";
import GroupHorizontalList from "./MyGroupProfileHorizontalList.vue";
// import GroupSkeletonLoader from "./GroupSkeletonLoader.vue";
// import commonFunctions from "@/common/commonFunctions";
import { mapGetters } from "vuex";

export default {
  components: { GroupHorizontalList },

  data: () => ({
    loading: false,
    // is_superuser: false,
  }),

  async created() {
    this.loading = true;
    await this.$store.dispatch("groups/fetchUpdates");
    this.loading = false;
  },

  computed: {
    ...mapGetters({
      getSuperUser: "user/getSuperUser",
    }),
    is_superuser() {
      return this.getSuperUser;
    },
    updates() {
      return this.$store.state.groups.updates;
    },
  },
  mounted() {
    // this.is_superuser = commonFunctions.isSuperUser();
  },
};
</script>
